import React, { useCallback } from 'react';
import { useState, useEffect } from 'react';
import { MotifButton } from '@ey-xd/motif-react';
import { MotifChip } from '@ey-xd/motif-react';
import {
  getOpportunitiesDetails,
  submitopportunity,
  submitopportunityV2,
} from '../../../services/pursuitLeaderServices';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Current_User,
  Loading_Modal_State,
  PL_Commit_State,
  PursuitLeaderTableRowDataState,
  Quaterly_OP_Details_State,
  Recoil_All_Accounts_Quarter_State,
  Recoil_Quarter_State,
  Refresh_Pl_Sidebar_Data,
  System_Date_Time_State,
} from '../../../recoil/recoil';
import { dateFormat, dateFormatMonth, structureMonth } from '../../../util/commonUtil';
import {
  QuarterTitle,
  SubHeaderContainer,
  SubmitButtonContainer,
  QuarterDates,
  ChipContainer,
  SubHeaderTitle,
} from './subHeader.styles';
import {
  BUTTON_TITLE,
  DATA_MISMATCH_ERROR,
  PAGE,
  SUB_HEADER,
} from '../../../constants/commonConstants';
import SuccessTransactionModal from '../../organisms/modals/SuccessTransactionModal';
import FailureTransactionModal from '../../organisms/modals/failureTransactionModal';
import { Pl_Submit_Success_Modal_State, Pl_Failure_Modal_State } from '../../../recoil/recoil';
import {
  QuaterlyDetailsChangeKeys,
  delay,
  getAlertBarDetails,
  initUserLogout,
  isCurrentUserExist,
} from '../../../util/commonFunctions';
import { isMobile } from 'react-device-detect';
import CustomErrorModal from '../../organisms/modals/customErrorModal';
import {
  getForecastSubmittedStatus,
  getLogOutStatus,
  userOnboardingSubmit,
} from '../../../services/commonServices';
import LoadingModal from '../../organisms/modals/loadingModal';
import { useNavigate } from 'react-router-dom';

const SubHeaderPL = () => {
  const [customErrorMessage, setCustomErrorMessage] = useState({
    show: false,
    headerText: undefined,
    message: undefined,
    args: undefined,
  });
  const [quarterData, setQuarterData] = useRecoilState(Recoil_Quarter_State);
  const [plCommitData, setPlCommitData] = useRecoilState(PL_Commit_State);
  const [plQuaterlyDetails, setPlQuaterlyDetails] = useRecoilState(Quaterly_OP_Details_State);
  const [forecastStatus, setForecastStatus] = useState({});
  const [showSubmitConfirmationModal, setShowSubmitConfirmationModal] = useRecoilState(
    Pl_Submit_Success_Modal_State,
  );
  const [showFailureSubmitModal, setShowFailureSubmitModal] =
    useRecoilState(Pl_Failure_Modal_State);
  const currentUser = useRecoilValue(Current_User);

  const allAccountsQuarterData = useRecoilValue(Recoil_All_Accounts_Quarter_State);
  const [quarterChipInfo, setQuarterChipInfo] = useState({});
  const [monthChipInfo, setMonthChipInfo] = useState({});

  const [systemDateTime, setSystemDateTime] = useRecoilState(System_Date_Time_State);

  const [currentPLRowData, setCurrentPLRowData] = useRecoilState(PursuitLeaderTableRowDataState);
  const [plRowData, setPlRowData] = useRecoilState(PursuitLeaderTableRowDataState);

  const [refreshPLSidebarData, setRefreshPLSidebarData] = useRecoilState(Refresh_Pl_Sidebar_Data);

  const [showLoadingModal, setShowLoadingModal] = useRecoilState(Loading_Modal_State);

  let alertStatusDetails;
  let updatedOpportunities;
  const navigate = useNavigate();

  const fetchForecastStatus = async () => {
    if (!quarterData) {
      return; // or handle the absence of quarterData accordingly
    }

    let reqPayload = {
      email: currentUser.email,
      role: currentUser.role,
      month: quarterData.month.toLowerCase(),
      year: quarterData.fiscal_year,
      accountId: currentUser.account_id,
    };

    try {
      const status = await getForecastSubmittedStatus(reqPayload);
      setForecastStatus({
        monthly_submission: status.monthly_submission,
      });
    } catch (error) {
      console.error('Error fetching forecast submit status:', error);
    }
  };

  useEffect(() => {
    fetchForecastStatus();
  }, []);

  const quarter = quarterData ? structureMonth(quarterData.quarter) : '';
  const fullMonth = quarterData ? structureMonth(quarterData.month) : '';
  const currentYear = quarterData ? quarterData.fiscal_year : '';
  const StartDate = quarterData ? dateFormatMonth(quarterData.current_month_start_date) : '';
  const EndDate = quarterData ? dateFormatMonth(quarterData.next2next_month_end_date) : '';
  const quarterStartDate = quarterData ? dateFormatMonth(quarterData.quarter_start_date) : '';
  const quarterEndDate = quarterData ? dateFormatMonth(quarterData.quarter_end_date) : '';
  const startMonth = quarterData ? quarterData.month : '';
  const endMonth = quarterData ? quarterData.next2next_month : '';
  const DueIn = quarterData ? quarterData.due_in : 0;

  let TodaysDate = systemDateTime ? new Date(systemDateTime) : new Date();
  let personaStartDateCheck = quarterData ? new Date(quarterData.persona_startdate) : new Date();
  let personaCloseDateCheck = quarterData ? new Date(quarterData.persona_closedate) : new Date();
  let IsSubmitDisabled = false;

  IsSubmitDisabled = !(TodaysDate >= personaStartDateCheck && TodaysDate <= personaCloseDateCheck)
    ? true // Disable
    : false; // Enable

  const checkforUpdatedOppotunitiesData = useCallback(() => {
    return new Promise(async (resolve, reject) => {
      try {
        await delay(7000); // Delay for 5 seconds
        let getOpportunitiesDetailsAPI = await getOpportunitiesDetails(currentUser.email);
        const updateOpportunites = getOpportunitiesDetailsAPI.opportunities;
        setShowLoadingModal(false);

        sessionStorage.setItem('CrmUpdatedOpportunities', JSON.stringify(updateOpportunites));
        if (updateOpportunites.length !== currentPLRowData.length) {
          //checks if count of opps in new and old list are same if not there is mismatch
          resolve({ isDataChanged: true, newPlRowData: updateOpportunites });
        } else {
          let opportunityMap = new Map(
            updateOpportunites.map(element => [element.opportunity_id, element]),
          );
          currentPLRowData.forEach(element => {
            if (opportunityMap.has(element.opportunity_id)) {
              //opp exists in map hence compare the opp data to check mismatch
              const oldData = element;
              const newData = opportunityMap.get(element.opportunity_id);
              if (
                newData.tov !== oldData.tov ||
                newData.awd !== oldData.awd ||
                newData.fiscal_month !== oldData.fiscal_month ||
                newData.fiscal_year !== oldData.fiscal_year
              ) {
                //check for mismatch in data
                resolve({ isDataChanged: true, newPlRowData: updateOpportunites });
              }
            } else {
              //opp does not exist in the map hence mismatch
              resolve({ isDataChanged: true, newPlRowData: updateOpportunites });
            }
          });
          resolve({ isDataChanged: false });
        }
      } catch (error) {
        reject(error);
      }
    });
  }, [getOpportunitiesDetails, currentPLRowData]);

  const handlePostData = async () => {
    setShowLoadingModal(true);

    const isUserExist = await isCurrentUserExist();

    if (isUserExist) {
      try {
        const { isDataChanged, newPlRowData } = await checkforUpdatedOppotunitiesData();
        if (isDataChanged) {
          updatedOpportunities = newPlRowData.map(newItem => {
            let matchingItem = plRowData.find(
              oldItem => oldItem.opportunity_id === newItem.opportunity_id,
            );
            if (!!matchingItem) {
              newItem.commit_status = matchingItem.commit_status;

              return {
                ...newItem,
              };
            } else {
              return newItem;
            }
          });

          setCustomErrorMessage({
            show: true,
            headerText: DATA_MISMATCH_ERROR.title,
            message: DATA_MISMATCH_ERROR.message,
            closeButtonText: DATA_MISMATCH_ERROR.buttonText,
            args: newPlRowData,
          });
          return;
        }
      } catch (error) {
        console.log('Something went wrong.', error);
        return;
      }
      const MONTH = quarterData.month;
      const YEAR = quarterData.fiscal_year;
      const QUARTER = quarterData.quarter;
      const snapDates = {
        fiscal_month_startdate: quarterData?.current_month_start_date,
        fiscal_month_enddate: quarterData?.current_month_end_date,
        fiscal_quarter_startdate: quarterData?.quarter_start_date,
        fiscal_quarter_enddate: quarterData?.quarter_end_date,
      };

      const rollingDates = {
        fiscal_month_startdate: quarterData?.quarter_start_date,
        fiscal_month_enddate: quarterData?.quarter_end_date,
      };
      let REQ_BODY;
      const crm_quaterly_response = QuaterlyDetailsChangeKeys(plQuaterlyDetails);
      const crm_full_res = QuaterlyDetailsChangeKeys(plRowData);

      if (Object.keys(plCommitData).length !== 0) {
        REQ_BODY = {
          forecast_table_details: {
            forecast_id: currentUser.email,
          },
          crm_update: plCommitData.crm_update,
          crm_quaterly_response: plCommitData.crm_quaterly_response,
          snap_dates: snapDates,
          rolling_dates: rollingDates,
          crm_full_res: crm_full_res,
        };
      } else {
        REQ_BODY = {
          forecast_table_details: {
            forecast_id: currentUser.email,
          },
          crm_update: [],
          crm_quaterly_response: crm_quaterly_response,
          snap_dates: snapDates,
          rolling_dates: rollingDates,
          crm_full_res: crm_full_res,
        };
      }
      const userOnboardingRequestBody = {
        email: currentUser.email,
        role: currentUser.role,
        performing_segment: null,
        onboarding_date: TodaysDate,
      };

      JSON.stringify(userOnboardingRequestBody);
      JSON.stringify(REQ_BODY);

      try {
        const userOnboarding = userOnboardingSubmit(userOnboardingRequestBody);
        if ((await userOnboarding).status == 200) {
          const response = await submitopportunityV2(
            MONTH,
            YEAR,
            QUARTER,
            REQ_BODY,
            currentUser.email,
          );

          if (response === true) {
            setShowSubmitConfirmationModal(true); // Showing Success Modal When Response is 200
            setPlCommitData({});
          } else {
            setShowFailureSubmitModal(true); // Showing Error Modal if any submit APIs Fail
          }
        } else {
          setShowFailureSubmitModal(true); // Showing Error Modal if User Onboarding API Fail
        }
      } catch (error) {
        setShowFailureSubmitModal(true); // Showing Error Modal for any other error
      }
    } else {
      setShowLoadingModal(false);
      getLogOutStatus(localStorage.getItem('userEmail'))
        .then(() => {
          localStorage.clear();
          sessionStorage.clear();
          navigate('/logout');
        })

        .catch(error => {
          console.error('Error logging out:', error);
        });
    }
  };

  const getChip = () => {
    return (
      <>
        <ChipContainer>
          {!isMobile && monthChipInfo != {} && (
            <MotifChip
              variant={monthChipInfo.type}
              type={
                monthChipInfo.userDropdownChip === 'Submitted' ||
                monthChipInfo.userDropdownChip === 'Missed'
                  ? 'outlined'
                  : undefined
              }
            >
              {monthChipInfo.userDropdownChip}
            </MotifChip>
          )}
        </ChipContainer>
      </>
    );
  };

  const renderQuarterInfo = () => {
    if (quarterData && quarterData.current_month_start_date === quarterData.quarter_start_date) {
      return (
        <>
          <SubHeaderTitle>
            <QuarterTitle>
              {fullMonth} | FY {currentYear}
              {getChip()}
            </QuarterTitle>

            <QuarterDates>
              Forecast Submission for {startMonth}-{endMonth} & {quarter} ({StartDate} - {EndDate})
            </QuarterDates>
          </SubHeaderTitle>
        </>
      );
    } else {
      return (
        <>
          <SubHeaderTitle>
            <QuarterTitle>
              {fullMonth} FY {currentYear}
              {getChip()}
            </QuarterTitle>

            <QuarterDates>
              Forecast Submission for {startMonth}-{endMonth} ({StartDate} - {EndDate})
            </QuarterDates>
          </SubHeaderTitle>
        </>
      );
    }
  };

  const getChipVariant = () => {
    if (forecastStatus && forecastStatus.monthly_submission === 'Submitted') {
      return 'success';
    } else if (DueIn === 0) {
      return 'error';
    } else if (!isNaN(parseInt(DueIn))) {
      if (parseInt(DueIn) > 6) {
        return 'warning';
      } else {
        return 'error';
      }
    }
    return 'defaultVariant';
  };

  useEffect(() => {
    if (quarterData != null && currentUser != null && allAccountsQuarterData != null) {
      getMotifChip();
    }
  }, [quarterData, currentUser, allAccountsQuarterData]);

  const getMotifChip = async () => {
    let apiPayload = {
      email: currentUser.email,
      role: currentUser.role,
      month: quarterData.month.toLowerCase(),
      year: quarterData.fiscal_year,
      accountId: currentUser.account_id,
    };

    try {
      alertStatusDetails = await getAlertBarDetails(
        allAccountsQuarterData[apiPayload.role],
        apiPayload,
        PAGE.FORECAST,
        systemDateTime,
      );
      const monthVariant =
        (alertStatusDetails.userDropdownChip &&
          alertStatusDetails.userDropdownChip.includes('Opens on')) ||
        alertStatusDetails.userDropdownChip.includes('Due on')
          ? 'monochrome-dark'
          : alertStatusDetails.type;

      setQuarterChipInfo({ ...alertStatusDetails, type: monthVariant });
    } catch (error) {
      console.error('Error fetching forecast submit status:', error);
    }

    try {
      alertStatusDetails = await getAlertBarDetails(
        allAccountsQuarterData[apiPayload.role],
        apiPayload,
        PAGE.FORECAST,
        systemDateTime,
      );
      const monthVariant =
        (alertStatusDetails.userDropdownChip &&
          alertStatusDetails.userDropdownChip.includes('Opens on')) ||
        alertStatusDetails.userDropdownChip.includes('Due on')
          ? 'monochrome-dark'
          : alertStatusDetails.type;

      setMonthChipInfo({ ...alertStatusDetails, type: monthVariant });
    } catch (error) {
      console.error('Error fetching forecast submit status:', error);
    }
  };

  return (
    <SubHeaderContainer>
      {renderQuarterInfo()}

      <SubmitButtonContainer>
        <MotifButton
          className={IsSubmitDisabled ? 'disableSubmitButton' : 'submitButton'}
          onClick={handlePostData}
          disabled={IsSubmitDisabled}
        >
          {BUTTON_TITLE.SUBMIT}
        </MotifButton>
        <LoadingModal showLoadingModal={showLoadingModal} />
        <SuccessTransactionModal showSubmitConfirmationModal={showSubmitConfirmationModal} />
        <FailureTransactionModal showFailureSubmitModal={showFailureSubmitModal} />
        <CustomErrorModal
          show={customErrorMessage.show}
          headerText={customErrorMessage.headerText}
          message={customErrorMessage.message}
          closeButtonText={customErrorMessage.closeButtonText}
          onClose={() => {
            setCustomErrorMessage({ show: false });
            // localStorage.removeItem("modifiedOpportunitiesData");
          }}
          onButtonClicked={() => {
            setPlRowData(updatedOpportunities);
            setRefreshPLSidebarData(!refreshPLSidebarData);
            setCurrentPLRowData(customErrorMessage.args);
            setCustomErrorMessage({ show: false });
            // window.location.reload(); // To refresh the Page
          }}
        />
      </SubmitButtonContainer>
    </SubHeaderContainer>
  );
};

export default SubHeaderPL;
